export default {
   allTasks: [],
   ownTasks: [],
   ownConfirm: {},
   departmentTasks: [],
}
